module.exports = __webpack_public_path__ + "media/images/icons/submit_evidence_chevron_green-b28db5b54fb4c03f99c6ee8015a5c346.svg";